import dayjs, { type Dayjs } from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(isSameOrBefore);
dayjs.extend(weekOfYear);

export const generateDateArray = (
  startDate: Dayjs,
  endDate: Dayjs,
  unit: 'day' | 'week' | 'month',
): Dayjs[] => {
  const dates: Dayjs[] = [];
  let currentDate = startDate;

  if (unit === 'week') {
    currentDate = currentDate.startOf('week');
  } else if (unit === 'month') {
    currentDate = currentDate.startOf('month');
  }

  while (currentDate.isSameOrBefore(endDate)) {
    dates.push(currentDate);
    currentDate = currentDate.add(1, unit);
  }

  return dates;
};
